import { InsuranceAge } from "@/case/models/CreateInsuranceCaseViewModel";

export interface AdInsuranceModel {
  adId: string;
  age: InsuranceAge | "";
  monthlyPremium: string;
}

export function InsuranceGiftVoucherPromotionActive(): boolean {
  const now = new Date().toISOString();
  return now > "2026-04-01" && now < "2026-04-30";
}